import { formatAmount } from "@/utils/utils";

const EMPTY_VALUE = "-";

const toStringOrNull = (value: unknown): string | null =>
  typeof value === "string" ? value : null;

export const parseAmount = (value: unknown): number => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const parsed = Number.parseFloat(String(value));

  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatStringAmount = (value: unknown): string =>
  formatAmount(parseAmount(value));

export const formatPaymentDate = (value: unknown): string => {
  const raw = toStringOrNull(value);
  if (!raw) {
    return EMPTY_VALUE;
  }

  const date = new Date(raw);

  return Number.isNaN(date.getTime())
    ? EMPTY_VALUE
    : new Intl.DateTimeFormat("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(date);
};

export const formatPaymentDateTime = (value: unknown): string => {
  const raw = toStringOrNull(value);
  if (!raw) {
    return EMPTY_VALUE;
  }

  const date = new Date(raw);

  return Number.isNaN(date.getTime())
    ? EMPTY_VALUE
    : new Intl.DateTimeFormat("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
};

export const formatText = (value: unknown): string =>
  value === null || value === undefined || value === ""
    ? EMPTY_VALUE
    : String(value);

export const formatPlaqueLabel = (label: string | null | undefined): string =>
  formatText(label?.replace(/STELLANTIS\s*&\s*YOU/gi, "S&Y"));

/**
 * Comme en V1, le compte affiche la concession du compte bancaire ; la plaque
 * ne sert que lorsque le compte est absent du référentiel.
 */
export const formatAccountLabel = (
  dealership: string | null | undefined,
  plaqueLabel: string | null | undefined,
): string =>
  dealership
    ? dealership.replace(/^S&Y\s+France\s+/i, "S&Y - ")
    : formatPlaqueLabel(plaqueLabel);

/**
 * La colonne « FAIT » est l'inverse de `to_do` : seul l'affichage a été
 * retourné, la donnée reste stockée et journalisée comme « reste à faire ».
 */
export const isDone = (toDo: boolean): boolean => !toDo;

export const isArchived = (row: { deleted_at?: string | null }): boolean =>
  Boolean(row.deleted_at);
